import apiConcierge from '@/api/concierge';
import { Media } from '@/mixins/media';

import LoadingDots from '@/components/loading_dot/LoadingDot.vue';
import AccountInfo from '@/components/account_info/AccountInfo.vue';

import flags from '@/config/flags.json';

export default {
  name: 'ConciergeCreate',
  components: { AccountInfo, LoadingDots },
  mixins: [Media],
  // eslint-disable-next-line max-lines-per-function
  data: function() {
    return {
      flags: { '': '-', ...flags },
      booleanOptions: [
        {
          name: 'Yes',
          value: 1
        },
        {
          name: 'No',
          value: 0
        }
      ],
      form: {
        screenName: '',
        firstName: '',
        lastName: '',
        email: '',
        isSuperConcierge: 0,
        isPartnerConcierge: 0,
        nationality: '',
        languages: [],
        descriptions: [],
        location: []
      }
    };
  },

  methods: {
    // eslint-disable-next-line complexity
    // eslint-disable-next-line max-lines-per-function
    handleOnSaveClick: async function() {
      try {
        this.$loading.start('concierge.create');
        await this.handleUploadImage();
        await apiConcierge.createConcierge(this.form);

        this.form = {
          screenName: '',
          firstName: '',
          lastName: '',
          email: '',
          isSuperConcierge: 0,
          isPartnerConcierge: 0,
          nationality: '',
          languages: [],
          descriptions: [],
          location: []
        };

        this.$toast.open({
          message: 'Concierge profile has been created successfully. ',
          position: 'top-right'
        });
      } catch (error) {
        // TODO: handle error correctly
        this.$toast.open({
          type: 'error',
          message: 'Something happens, concierge profile creation was failed. ',
          position: 'top-right'
        });
      }

      this.$loading.end('concierge.create');
    },

    handleOnIconChange: function(e) {
      this.iconFile = e.target.files[0];
    },

    handleOnProfileChange: function(e) {
      this.profileFile = e.target.files[0];
    },

    handleUploadImage: async function() {
      const { iconFile, profileFile } = this;

      // Image photo on small avatar chat
      if (iconFile) {
        const uploadedIcon = await this.uploadImage(iconFile, 'agent');
        this.form.profileIcon = uploadedIcon.url;
      }

      // Image photo on concierge profile
      if (profileFile) {
        const uploadedProfile = await this.uploadImage(profileFile, 'agent');
        this.form.profilePhoto = uploadedProfile.url;
      }
    }
  }
};
